const ELEMENT = 'span';
const ListItemDefaultElement = ELEMENT;

export { ListItemDefaultElement };
